import { render, staticRenderFns } from "./FormControlTypeText.vue?vue&type=template&id=ef4a87b4&scoped=true"
import script from "./FormControlTypeText.vue?vue&type=script&lang=js"
export * from "./FormControlTypeText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4a87b4",
  null
  
)

export default component.exports